import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "customize_rate_modal",
  "data-toggle": "modal"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title",
    id: "customize_rate_modal"
  }, "Customize rate"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" })
  ])
], -1)
const _hoisted_5 = {
  key: 1,
  class: "modal-body"
}
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = { class: "table table-row-dashed table-row-gray-300 align-middle gs-0" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, "Level"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, "Rate"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, "Night bonus"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px text-end" }, "Weekend bonus")
  ])
], -1)
const _hoisted_9 = { class: "fs-5 fw-bold" }
const _hoisted_10 = { class: "d-flex" }
const _hoisted_11 = ["placeholder", "disabled", "value", "onChange"]
const _hoisted_12 = ["disabled", "placeholder", "value", "onChange"]
const _hoisted_13 = { class: "text-end d-flex justify-content-end" }
const _hoisted_14 = ["disabled", "placeholder", "value", "onChange"]
const _hoisted_15 = { class: "modal-footer" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-light",
  "data-bs-dismiss": "modal"
}, " Close ", -1)
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1"
}
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Save ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
          : _createCommentVNode("", true),
        (Object.keys(_ctx.model).length > 0 && !_ctx.isLoading)
          ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("table", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderedLevels, (entity) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: entity.id
                      }, [
                        _createElementVNode("td", _hoisted_9, _toDisplayString(entity.name), 1),
                        _createElementVNode("td", _hoisted_10, [
                          _createElementVNode("input", {
                            class: "form-control w-100",
                            placeholder: 
                        _ctx.getLevelBaseRate(
                          _ctx.getPlaceholder(
                            _ctx.model[entity.id].skill_id,
                            'base_rate'
                          ),
                          entity.id
                        )
                      ,
                            disabled: _ctx.isLoading,
                            value: _ctx.model[entity.id].base_rate,
                            onChange: 
                        event =>
                          (_ctx.model[entity.id].base_rate = event.target.value)
                      ,
                            style: {"height":"32px !important"}
                          }, null, 40, _hoisted_11)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("input", {
                            class: "form-control w-100",
                            disabled: _ctx.isLoading,
                            placeholder: 
                        _ctx.getPlaceholder(_ctx.model[entity.id].skill_id, 'night_bonus')
                      ,
                            value: _ctx.model[entity.id].night_bonus,
                            onChange: 
                        event =>
                          (_ctx.model[entity.id].night_bonus = event.target.value)
                      ,
                            style: {"height":"32px !important"}
                          }, null, 40, _hoisted_12)
                        ]),
                        _createElementVNode("td", _hoisted_13, [
                          _createElementVNode("input", {
                            class: "form-control w-100",
                            disabled: _ctx.isLoading,
                            placeholder: 
                        _ctx.getPlaceholder(
                          _ctx.model[entity.id].skill_id,
                          'weekend_bonus'
                        )
                      ,
                            value: _ctx.model[entity.id].weekend_bonus,
                            onChange: 
                        event =>
                          (_ctx.model[entity.id].weekend_bonus = event.target.value)
                      ,
                            style: {"height":"32px !important"}
                          }, null, 40, _hoisted_14)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])), [
              [_directive_loading, _ctx.isSoftLoading]
            ])
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("button", {
            class: "btn btn-success",
            disabled: _ctx.isSavingRate,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleSave && _ctx.handleSave(...args)))
          }, [
            (_ctx.isSavingRate)
              ? (_openBlock(), _createElementBlock("span", _hoisted_18))
              : _createCommentVNode("", true),
            _hoisted_19
          ], 8, _hoisted_17)
        ])
      ])
    ])
  ]))
}